import type { CSSProperties, FC, ReactNode } from "react";

export interface KemPageShellProps {
  outerStyle?: CSSProperties;
  /** Content inside the white card (header area, chat, composer). */
  children: ReactNode;
  /** Siblings after the card inside the outer wrapper (e.g. tour, modals). */
  afterCard?: ReactNode;
}

/**
 * Shared KEM chat layout: centered column, max width, full-height card on large screens.
 */
const KemPageShell: FC<KemPageShellProps> = ({
  outerStyle,
  children,
  afterCard,
}) => (
  <div
    className="flex w-full min-w-0 items-start justify-center overflow-hidden px-3 pb-5 sm:px-5"
    style={outerStyle}
  >
    <div className="relative flex min-h-0 w-full min-w-0 max-w-[700px] flex-col rounded-3xl bg-white px-4 pb-5 supports-[height:100dvh]:h-full sm:px-5">
      {children}
    </div>
    {afterCard}
  </div>
);

export default KemPageShell;
